import 'sharedreact/data/RegisterClasses';
import 'workspaces/common/data/RegisterClasses';

import ClassFactory from 'sharedreact/utils/ClassFactory';

import Agent from 'workspaces/launcher/data/Agent';
import IdentityProviders from 'workspaces/launcher/data/IdentityProviders';
import LdapConfig from 'workspaces/launcher/data/LdapConfig';
import OpenIDConfig from 'workspaces/launcher/data/OpenIDConfig';
import Token from 'workspaces/launcher/data/Token';

function _registerClasses () {
  ClassFactory.registerClassWithName('Agent', Agent);
  ClassFactory.registerClassWithName('IdentityProviders', IdentityProviders);
  ClassFactory.registerClassWithName('LdapConfig', LdapConfig);
  ClassFactory.registerClassWithName('OpenIDConfig', OpenIDConfig);
  ClassFactory.registerClassWithName('Token', Token);
}

class RegisterClasses {
  constructor () {
    _registerClasses();
  }
}

export default new RegisterClasses();